module.exports = __webpack_public_path__ + "static/media/image-gallery-12.31924376.jpg";